// Negotiation list: status filter values and the Excel/CSV export. The list is
// loaded in full and paged on the client, so the export reads the filtered
// rows directly. Download helpers are shared with the Plan & Procurement list.

import { downloadSheet } from '../../Procurement/utils/procurementList';
import { getStatusMeta, PACKAGE_STATUS } from './negotiationStatus';

// `value` is the BE package `statusLabel`.
export const NEGOTIATION_STATUSES = [
  { value: PACKAGE_STATUS.OPEN, icon: 'ri-door-open-line', stat: 'muted' },
  {
    value: PACKAGE_STATUS.IN_PROGRESS,
    icon: 'ri-loader-4-line',
    stat: 'open',
  },
  {
    value: PACKAGE_STATUS.DONE,
    icon: 'ri-checkbox-circle-line',
    stat: 'done',
  },
];

// contractType 2 = Spot (be#451 A-8), anything else = Term.
export const getPeriodLabel = row =>
  Number(row?.contractType) === 2 ? 'Spot' : 'Term';

const toExportRow = (row, isSupplier) => ({
  'ID Proc': row.procurementNumber || '',
  Title: row.titleProcurement || '',
  Period: getPeriodLabel(row),
  Product: row.productName || '',
  'Product Type': row.productTypeName || '',
  'Cargo Total': row.cargoTotal ?? '',
  ...(isSupplier ? {} : { 'Total Partners': row.partnerTotal ?? '' }),
  Status: getStatusMeta(row.statusLabel).label,
});

export const exportNegotiationList = (
  rows,
  { format, sheetName, isSupplier }
) =>
  downloadSheet(
    rows.map(row => toExportRow(row, isSupplier)),
    { format, sheetName, prefix: 'Negotiation' }
  );
